import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Observable } from 'rxjs';

@Component({
  selector: 'related-row',
  templateUrl: './related-row.template.html',
  styleUrls: ['./related-row.styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RelatedRow {
  @Input() row$: any;

  constructor(
  ) { }

  ngOnInit() {
  }
}





// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/related-row/related-row.component.ts